//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"DecimalPlaces",1,0],[0,"DeletedHolesDisplay",1,0],[0,"DepthMeasurementDatum",1,0],[0,"DisplayAllTextInUpperCase",1,0],[0,"DisplayPartBodyName",1,0],[0,"MergeCellsWithSameSize",1,0],[0,"ReportTapHoleSizeForThreadedHoles",1,0],[0,"ShowColumns",1,0],[0,"SizeFormat",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.HoleTableSettingsFormatBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.HoleTableSettingsFormatBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.HoleTableSettingsFormatBuilder.ShowColumnsType = Object.freeze({
    "Xy" : "Xy", "Xyz" : "Xyz", "All" : "All"});

SPLM.Annotations.HoleTableSettingsFormatBuilder.SizeFormatType = Object.freeze({
    "DisplayInSummaryRows" : "DisplayInSummaryRows", "DisplayInColumn" : "DisplayInColumn"});

SPLM.Annotations.HoleTableSettingsFormatBuilder.DeletedHolesDisplayType = Object.freeze({
    "Strikethrough" : "Strikethrough", "HideText" : "HideText", "Remove" : "Remove"});

SPLM.Annotations.HoleTableSettingsFormatBuilder.DepthMeasurementDatumType = Object.freeze({
    "TopBottomFace" : "TopBottomFace", "BaseFace" : "BaseFace", "StepFace" : "StepFace"});

export default SPLM;